import { Observable } from 'rxjs';
import _ from 'lodash';
import { ActionsObservable } from 'redux-observable';
import { Store } from 'redux';

import { selectOrganization, selectUserLocations } from 'entities/user/selectors';
import { STORE as STORE_USER } from 'entities/user/constants';
import RolesApi from 'entities/role/api';
import OrganizersApi from 'entities/organizer/api';
import LocationApi from 'entities/location/api';
import { selectRoles } from 'entities/role/selectors';
import { showErrorAction } from 'containers/Notification/actions';

import {
  initSuccessAction,
  initFailedAction,
  updateSuccessAction,
  updateFailedAction,
  UpdateAction,
} from './actions';
import { INIT, SET_FETCH_PARAMS, UPDATE } from './constants';
import { selectFetchParams } from './selectors';

const init = (action$: ActionsObservable<any>, store: Store) =>
  action$.ofType(INIT, STORE_USER, SET_FETCH_PARAMS).mergeMap(() => {
    const state = store.getState();
    const fetchParams = selectFetchParams(state);
    const organization = selectOrganization(state);

    const pageNum = fetchParams.get('pageNum');
    const limit = fetchParams.get('limit');
    const search = fetchParams.get('search');
    const skip = limit * pageNum;

    if (!organization) {
      return [];
    }

    const actions: Observable<any>[] = [];

    const roles = selectRoles(state);
    if (roles.size === 0) {
      actions.push(RolesApi.fetchAll());
    }

    const locations = selectUserLocations(state);
    if (locations.size === 0) {
      actions.push(LocationApi.fetchAll());
    }

    actions.push(OrganizersApi.fetch(organization, { limit, skip, search }));

    if (actions.length === 0) {
      return Observable.of(initSuccessAction());
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)));
  });

const organizerActions = (action$: ActionsObservable<UpdateAction>, store: Store) =>
  action$.ofType(UPDATE).mergeMap((action) => {
    const state = store.getState();
    const organization = selectOrganization(state);
    if (!organization) {
      return [];
    }
    return (action.unblock ? OrganizersApi.unblock : OrganizersApi.block)(action.userId)
      .concatMap(() => OrganizersApi.fetchById(action.userId))
      .concat(Observable.of(updateSuccessAction(action.userId)))
      .catch((e) =>
        Observable.of(
          updateFailedAction(action.userId, e),
          showErrorAction('An error occurred, please try again.')
        )
      );
  });

export default [init, organizerActions];
